import { type FC } from 'react';
import { getProductTileAdData } from 'dibs-google-ad-manager/exports/adHelpers.ts';
import { ProductTileAd } from 'dibs-google-ad-manager/exports/ProductTileAd.tsx';
import { type AdProductTile } from 'dibs-google-ad-manager/exports/types.ts';
import { useAbsentAdHandler } from 'dibs-google-ad-manager/exports/hooks.ts';

import dibsCss from 'dibs-css';
import classnames from 'classnames';
import styles from './GridTileAd.module.css';

type Props = {
    adMap: Record<number, Record<number, number>>;
    columnIndex: number;
    index: number;
    placement: string;
    isDesktop: boolean | undefined;
    areDisplayAdsEnabled: boolean | null | undefined;
};

const TileAd: FC<{ ad: AdProductTile }> = ({ ad }) => {
    const { isAbsentAd, onAbsentAd } = useAbsentAdHandler(ad.elementId);

    return isAbsentAd ? null : (
        <div
            className={classnames(
                styles.wrapper,
                dibsCss.flex,
                dibsCss.justifyCenter,
                dibsCss.itemsCenter,
                dibsCss.overflowHidden,
                dibsCss.wFull,
                dibsCss.mbSmall,
                dibsCss.pSmaller,
                dibsCss.border,
                dibsCss.borderSolid,
                dibsCss.borderDolphin
            )}
        >
            <div className={styles.scaler}>
                <ProductTileAd
                    {...ad}
                    lazyLoad
                    onAbsentAd={onAbsentAd}
                    containerClassName={classnames(
                        dibsCss.block,
                        dibsCss.wFull,
                        dibsCss.hFull,
                        dibsCss.minW0
                    )}
                />
            </div>
        </div>
    );
};

export const GridTileAd: FC<Props> = ({
    adMap,
    columnIndex,
    index,
    placement,
    isDesktop,
    areDisplayAdsEnabled,
}) => {
    if (!areDisplayAdsEnabled || !isDesktop) {
        return null;
    }

    const adIndex = adMap[columnIndex]?.[index];
    if (adIndex === undefined) {
        return null;
    }

    const adData = getProductTileAdData({
        uriRef: placement,
        deviceType: 'desktop',
    });

    const ad = adData[adIndex];
    if (!ad) {
        return null;
    }

    return <TileAd ad={ad} />;
};
